import {
  GoogleLoginProvider,
  SocialAuthServiceConfig,
} from '@abacritt/angularx-social-login';
import { Provider } from '@angular/core';

export const provideGoogleService = (GOOGLE_ID: string): Provider => {
  const provider: Provider = {
    provide: 'SocialAuthServiceConfig',
    useValue: {
      autoLogin: false,
      providers: [
        {
          id: GoogleLoginProvider.PROVIDER_ID,
          provider: new GoogleLoginProvider(GOOGLE_ID),
        },
      ],
      onError: err => {
        console.error(err);
      },
    } as SocialAuthServiceConfig,
  };
  return provider;
};
